export const copy = {
  activate: 'Activate',
  active_tab: 'Active',
  add_button_button_link_title: 'Button Link',
  add_button_form_control_label_1: 'Use preset link',
  add_button_form_control_label_2: 'Customize link',
  add_button_form_label_text:
    'Select a preset link or enter a custom link for your message’s primary button.',
  add_button_input_1_helper_text:
    'This is the text that will appear on the button for users to see! Limit to x characters.',
  add_button_input_1_label: 'Button Text',
  add_button_input_2_helper_text:
    'This link won’t open automatically on click. Ensure your site listens for the postMessage event to handle navigation',
  add_button_input_2_label: 'Link',
  add_button_post_message_description:
    'This message will be sent to your site when the button is clicked.',
  add_button_post_message_input_helper_text:
    'A message emitted by the iframed widget upon a user click, which your site can listen for and handle.',
  add_button_post_message_link_text: 'Learn more',
  add_button_post_message_title: 'Configure postMessage (Optional)',
  add_button_title: 'Add a Button',
  add_button_post_message_input_label: 'Post Message',
  all_tab: 'All',
  back_button: 'Back',
  cancel_button: 'Cancel',
  cancel_dialog_title: 'Cancel?',
  cancel_message: "Are you sure you want to cancel? Your progress won't be saved if you leave.",
  close_aria_label: 'close',
  conditions_form_placeholder: 'Conditions form goes here',
  conditions_step: 'Conditions',
  confirm_step: 'Confirm',
  confirm_summary_placeholder: 'Confirm summary goes here',
  create_insight_button: 'Create Insight',
  create_insight_title: 'Create Your Insight',
  created_on_date: 'Created on _1{date}',
  custom_insights_title: 'Custom Insights',
  customize_form_placeholder: 'Customize form goes here',
  customize_step: 'Customize',
  disable: 'Disable',
  disabled_tab: 'Disabled',
  discard_changes_button: 'Discard Changes',
  finish_button: 'Launch Insight',
  keep_editing_button: 'Keep Editing',
  loading_insights: 'Loading insights...',
  next_button: 'Next',
  num_insights_generated: '_1{} Insights generated',
  one_insight_generated: '1 Insight generated',
  pending_tab: 'Pending',
  preview_card_read_more: 'Read more',
  preview_card_logo_alt: 'MX',
}
